export enum ContactSubject {
	FEATURE_REQUEST = "feature_request",
	BUG_REPORT = "bug_report",
	ACCOUNT_REMOVAL = "account_removal",
	GENERAL = "general",
}
